<template>
  <div>
    <b-col>
      <div class="row">
        <div class="col-sm-8">
          <p>
            <strong>DEMANDAS</strong>
          </p>
        </div>
        <div class="col-sm-4 text-right">
          <button
            class="btn btn-sm btn-success"
            type="button"
            @click="initForm()"
            :disabled="isCustomer ? true : !CREATE"
          >
            Añadir demanda
          </button>
        </div>
      </div>
    </b-col>

    <section class="proj-page-section comments">
      <section
        class="without"
        v-if="!lstDemands.length > 0"
        style="margin-top: 0px"
      >
        <div class="row">
          <figure class="text-center">
            <img src="img/sin_datos.png" alt width="150px" />
          </figure>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <h1>Oops!</h1>
            <h4>
              No hay demandas
              <br />para este deudor.
            </h4>
          </div>
        </div>
      </section>

      <section v-else class="mt-2">
        <b-table
          :hover="true"
          :striped="true"
          :bordered="false"
          :small="false"
          :fixed="false"
          responsive="sm"
          :items="lstDemands"
          :fields="fields"
          :select-mode="'single'"
          selectable
          @row-selected="onRowSelected"
        >
          <template slot="status" slot-scope="data">
            <b-badge :variant="getBadge(data.item.status)">{{
              getTextStatus(data.item.status)
            }}</b-badge>
          </template>

          <template slot="date" slot-scope="data">{{
            formatDate(data.item.date)
          }}</template>

          <template slot="created_at" slot-scope="data">{{
            formatDate(data.item.created_at)
          }}</template>

          <template slot="actions" slot-scope="data">
          <!-- <template v-slot:cell(actions)="data"> -->
            <b-button
              size="sm"
              variant="primary"
              class="mr-1"
              title="ver"
              @click="viewData(data.item)"
              :disabled="!READ"
            >
              <i class="fa fa-eye"></i>
            </b-button>

            <b-button
              size="sm"
              variant="success"
              class="mr-1"
              title="Editar"
              @click="editData(data.item)"
              :disabled="isCustomer ? true : !UPDATE"
            >
              <i class="fa fa-edit"></i>
            </b-button>

            <b-button
              size="sm"
              variant="warning"
              class="mr-1"
              title="Descargar gestiones"
              @click="getPDF(data.item.id)"
              :disabled="isCustomer ? true : !READ"
            >
              <i class="fa fa-download"></i>
            </b-button>

            <b-button
              size="sm"
              variant="danger"
              @click="deleteData(data.item)"
              title="Eliminar"
              :disabled="isCustomer ? true : !DELETE"
            >
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
        </b-table>
      </section>

      <demand-management-component
        v-if="this.demandSelected.id"
        :demand="this.demandSelected"
      />
    </section>

    <!-- MODAL PARA LAS DEMANDA -->
    <div class="modal fade" id="dlgData">
      <div class="modal-dialog modal-dialog-centered modal-success modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">DEMANDA</h4>
            <button type="button" class="close" @click="closeForm()">
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form
              @submit.prevent="saveData()"
              method="post"
              v-if="data.debtor_id"
              enctype="multipart/form-data"
            >
              <b-row>
                <b-col cols="11" sm="11" class="center-block">
                  <b-row>
                    <b-col sm="12" v-if="errores.length">
                      <b-alert show variant="danger">
                        <b>Por favor corrige los siguientes errores:</b>
                        <ul>
                          <li v-for="(error, index) in errores" :key="index">
                            {{ error }}
                          </li>
                        </ul>
                      </b-alert>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="4">
                      <b-form-group>
                        <label for="txtFecha">Fecha</label>
                        <b-form-input
                          type="date"
                          id="txtFecha"
                          v-model="data.date"
                          :disabled="disabledForm"
                          :max="maxDate"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col sm="4">
                      <b-form-group>
                        <label for="cmbEstado">Estado</label>
                        <b-form-select
                          v-model="data.status"
                          id="cmbEstado"
                          :disabled="disabledForm"
                        >
                          <template slot="first">
                            <option :value="null">-- Seleccione --</option>
                          </template>
                          <option value="P">Presentada</option>
                          <option value="R">Rechazada</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="4">
                      <b-form-group>
                        <label for="cmbTipoDemanda">Tipo demanda</label>
                        <b-form-select
                          v-model="data.demand_type"
                          id="cmbTipoDemanda"
                          :disabled="disabledForm"
                        >
                          <template slot="first">
                            <option :value="null"
                              >-- Seleccione el tipo --</option
                            >
                          </template>
                          <option
                            v-for="item in lstType"
                            :key="item.id"
                            :value="item.id"
                            >{{ item.name }}</option
                          >
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <b-form-group>
                        <label for="cmbRadicado">¿Radicado?</label>
                        <b-form-select
                          v-model="data.settled"
                          id="cmbRadicado"
                          :disabled="disabledForm"
                          @change="settledChange()"
                        >
                          <template slot="first">
                            <option :value="null">-- Seleccione --</option>
                          </template>
                          <option value="S">Si</option>
                          <option value="N">No</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="4">
                      <b-form-group>
                        <label for="txtNumeroRadicado"
                          >Número de radicado</label
                        >
                        <b-form-input
                          type="text"
                          id="txtNumeroRadicado"
                          v-model="data.number_filed"
                          :disabled="data.settled == 'S' ? disabledForm : true"
                          maxlength="10"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col sm="5">
                      <b-form-group>
                        <label for="cmbComercial">Abogado</label>
                        <b-form-select
                          id="cmbComercial"
                          v-model="data.staff_id"
                          :disabled="role_id == 5 ? true : disabledForm"
                        >
                          <template slot="first">
                            <option :value="null">-- Selecione --</option>
                          </template>
                          <option
                            v-for="item in lstStaffs"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name }} {{ item.last_name }} -
                            {{ item.type_name }}
                          </option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="12">
                      <strong>
                        <p>Juzgado</p>
                      </strong>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <b-form-group>
                        <label for="cmbDepartamentoFiltro">Departamento</label>
                        <b-form-select
                          v-model="data.zone_id"
                          id="cmbDepartamentoFiltro"
                          @change="getCitiesByZone(data.zone_id)"
                          :disabled="disabledForm"
                        >
                          <template slot="first">
                            <option :value="null">
                              -- Por favor seleccione una opción --
                            </option>
                          </template>

                          <option
                            v-for="item in lstDepartamento"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col>
                      <b-form-group>
                        <label for="cmbCiudadFiltro">Ciudad</label>
                        <b-form-select
                          v-model="data.city_id"
                          id="cmbCiudadFiltro"
                          @change="getJudgeds()"
                          :disabled="disabledForm || data.zone_id == null"
                        >
                          <template slot="first">
                            <option :value="null">
                              -- Por favor seleccione una opción --
                            </option>
                          </template>

                          <option
                            v-for="item in lstCiudad"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="5">
                      <b-form-group>
                        <label for="cmbJuzgado">Juzgado</label>
                        <b-form-select
                          id="cmbJuzgado"
                          v-model="data.judged_id"
                          :disabled="disabledForm || data.city_id == null"
                        >
                          <template slot="first">
                            <option :value="null">-- Selecione --</option>
                          </template>
                          <option
                            v-for="item in lstJudgeds"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.number }} - {{ item.name }}
                          </option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="disabledForm == false">
                    <b-col sm="12">
                      <label>Importar documentos</label>
                      <b-form-file
                        :browse-text="'Buscar'"
                        v-model="files"
                        :state="Boolean(files)"
                        v-on:change="onImageFile"
                        placeholder="Elija el/los archivos o suéltelo aquí ..."
                        drop-placeholder="Suelta el/los archivos aquí ..."
                        multiple
                      ></b-form-file>
                    </b-col>
                  </b-row>

                  <b-row class="mt-2">
                    <b-col sm="12">
                      <b-form-group>
                        <label for="txtMedidas">Comentario</label>
                        <b-form-textarea
                          rows="4"
                          id="txtMedidas"
                          no-resize
                          v-model="data.precautionary_measure"
                          maxlength="250"
                          :disabled="disabledForm"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="!disabledForm">
                    <b-col sm="4" class="center-block">
                      <b-button
                        type="submit"
                        variant="success"
                        class="btn-sm col-sm-12"
                        :disabled="disabledForm"
                        >Guardar</b-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA LAS DEMANDAS -->
  </div>
</template>

<script>
import moment from "moment";
import DemandManagementComponent from "@/components/DemandManagement.vue";

export default {
  name: "Legal",
  components: {
    DemandManagementComponent,
  },
  props: {
    debtor_id: {
      type: String,
      default: null,
    },
    customer_name: {
      type: String,
      default: null,
    },
    total_debt: {
      type: String,
      default: null,
    }
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),
      isCustomer: false,
      // CABECERAS PARA LA TABLA DE LOS AGREEMENTS
      fields: [
        {
          key: "selected",
          sortable: false,
          label: "",
          class: "options-column",
        },
        { key: "number", label: "# Interno" },
        { key: "_number_filed", label: "Radicado" },
        { key: "demand_type_name", label: "Tipo" },
        { key: "status_name", label: "Estado" },
        { key: "name", label: "Juzgado" },
        { key: "city_name", label: "Ciudad" },
        { key: "date", label: "Fecha" },
        { key: "user_name", label: "Creado por" },
        { key: "actions", label: "Opciones" },
      ],
      demandSelected : {id: null},
      lstDemands: [],
      isEdit: false,
      disabled: false,
      datos: [],
      errores: [],
      table: "demands",
      lstStaffs: [],
      lstJudgeds: [],
      isEditData: false,
      disabledForm: false,
      data: {
        number: null,
        demand_type: null,
        number_filed: null,
        date: null,
        debtor_id: null,
        judged_id: null,
        staff_id: null,
        status: null,
        precautionary_measure: null,
        settled: null,
        zone_id: null,
        city_id: null,
      },
      files: [],
      lstType: [],
      lstDepartamento: [],
      lstCiudad: [],
      // ------------------------------------------------------------------------
      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      // ------------------------------------------------------------------------
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
    };
  },
  created() {
    this.enabledActions();
    var auth = localStorage.getItem("auth");
    auth = JSON.parse(auth);
    this.isCustomer = auth[0].debtor_id != null ? true : false;
    this.getData();
  },

  methods: {
    enabledActions() {
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth)[0];
      this.CREATE = auth.create == 1;
      this.READ = auth.read == 1;
      this.UPDATE = auth.update == 1;
      this.DELETE = auth.delete == 1;
    },
    getData() {
      showLoader();
      let id = this.$route.params.id;
      // CARGAR EL LISTADO DE DEMANDAS
      this.$http
        .get(`${this.$urlApi}demands/debtor/${id}?token=${this.token}`)
        .then(
          (response) => {
            this.lstDemands = response.data.data;
          },
          (error) => {
            console.log(error);
            this.errores = getMsgError(error);
          }
        );
      hideLoader();
    },
    getRowCount(items) {
      return items.length;
    },
    getBadge(status) {
      return getBadge(status);
    },
    getTextStatus(status) {
      return getTextStatus(status);
    },
    formatDate(value) {
      return moment(String(value)).format("DD/MM/YYYY");
    },
    initParameters() {
      this.demandSelected = {id: null},

      this.$http.get(`${this.$urlApi}staffs/debtor/${this.debtor_id}?token=${this.token}`).then(
          response => {
            this.lstStaffs = response.data.data;
          },
          error => {
            console.log(error);
          }
        );

      //DEPARTAMENTOS DE COLOMBIA
      this.$http.get(`${this.$urlApi}zones/1?token=${this.token}`).then(
        (response) => {
          this.lstDepartamento = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      //TIPOS DE DEMANDAS
      this.$http.get(`${this.$urlApi}parameters/22?token=${this.token}`).then(
        (response) => {
          this.lstType = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    settledChange(){
      this.data.number_filed = this.data.settled == "S" ? this.data.number_filed : null;
    },
    getCitiesByZone(zone_id) {

      this.lstJudgeds = [];

      if (zone_id) {
        showLoader();
        this.$http
          .get(`${this.$urlApi}cities/${zone_id}?token=${this.token}`)
          .then(
            (response) => {
              this.lstCiudad = response.data.data;

              hideLoader();
            },
            (error) => {
              console.log(error);
              hideLoader();
            }
          );
      }

      if (this.data.id == null) {
        this.data.city_id = null;
      }

    },
    getJudgeds() {
      if (this.data.id == null) this.data.judged_id = null;
      // ENVIAR EL ID DE LA CIUDAD
      this.$http
        .get(
          `${this.$urlApi}judgeds/number/null/zone_id/null/city_id/${this.data.city_id}?token=${this.token}`
        )
        .then(
          (response) => {
            this.lstJudgeds = response.data.data;
          },
          (error) => {
            console.log(error);
          }
        );
    },
    initForm() {
      this.initParameters();
      this.errores = [];
      $("#dlgData").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.isEditData = false;

      this.files = [];

      // INICIALIZAR LOS CAMPOR DEL ACUERDO
      this.data.number = null;
      this.data.demand_type = null;
      this.data.number_filed = null;
      //this.data.date = null
      this.data.debtor_id = this.debtor_id;
      this.data.judged_id = null;
      this.data.staff_id = null;
      this.data.precautionary_measure = null;
      this.data.status = null;
      this.data.settled = null;
      this.data.zone_id = null;
      this.data.city_id = null;

      // SI INGRESA UN ABOGADO
      if(this.role_id == 5){
        var auth = JSON.parse(localStorage.getItem("auth"))[0];
        this.data.staff_id = auth.staff_id;
      }


      $("#dlgData").modal("show");
    },
    editData(item) {
      // console.log(item);
      this.initParameters();
      this.errores = [];
      $("#dlgData").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.data = Object.assign({}, item);

      this.files = [];
      this.getCitiesByZone(this.data.zone_id);
      this.getJudgeds();
      this.isEditData = true;
      $("#dlgData").modal("show");
    },
    viewData(item) {
      // console.log(item);
      this.initParameters();
      $("#dlgData").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.data = Object.assign({}, item);
      this.getCitiesByZone(this.data.zone_id);
      this.getJudgeds();
      this.disabledForm = true;
      $("#dlgData").modal("show");
    },
    saveData() {
      if (this.isEditData) {
        this.updateDate();
      } else {
        this.$swal({
          title: "Guardar",
          text: "¿Está seguro que toda la información ingresada es correcta?",
          type: "question",
          showCancelButton: true,
          cancelButtonText: "Volver",
          confirmButtonText: "Si",
        }).then((result) => {
          if (result.value) {
            this.ceateData();
          }
        });
      }
    },
    ceateData() {
      showLoader();

      this.datos = JSON.stringify(this.data);
      let formData = new FormData();
      formData.append("data", JSON.stringify(this.data));

      for (let i = 0; i < this.files.length; i++) {
        formData.append("documents[]", this.files[i]);
      }

      this.$http
        .post(`${this.$urlApi}demands?token=${this.token}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(function (response) {
          //console.log(response)

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Demanda guardada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              // CERRAR EL MODAL Y LISTAR EL CONTRATO GUARDADO
              this.data.debtor_id = null;
              this.lstStaffs = [];
              this.getData();
              $("#dlgData").modal("hide");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    updateDate() {
      // COMO ES UN OBJETO FormData SE DEBE ENVIAR UN POST Y CAMBIAR EL METODO A PUT, SOLO SIRVE PARA LARAVEL
      showLoader();
      this.datos = JSON.stringify(this.data);
      let formData = new FormData();
      formData.append("data", JSON.stringify(this.data));
      // formData.append("document", this.files);

      for (let i = 0; i < this.files.length; i++) {
        formData.append("documents[]", this.files[i]);
      }

      formData.append("_method", "PUT");

      this.$http
        .post(
          `${this.$urlApi}demands/${this.data.id}?token=${this.token}`,
          formData,
          { headers: { "Content-Type": undefined } }
        )
        .then(function (response) {
          //console.log(response)

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Demanda actualizada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              // CERRAR EL MODAL Y LISTAR EL CONTRATO GUARDADO
              this.data.debtor_id = null;
              this.lstStaffs = [];
              this.getData();
              $("#dlgData").modal("hide");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    deleteData(item) {
      console.log(item);

      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar la demanda ?",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(`${this.$urlApi}demands/${item.id}?token=${this.token}`, {
              headers: { "Content-Type": "application/json" },
            })
            .then(function (response) {
              //console.log(response)
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Demanda eliminada correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              }).then((result) => {
                if (result.value) {
                  this.getData();
                }
              });
            })
            .catch((error) => {
              console.log(error);
              hideLoader();
            });
        }
      });
    },
    closeForm() {
      this.isEditData = false;
      this.disabledForm = false;
      $("#dlgData").modal("hide");
    },
    onImageFile(e) {
      let lstFiles = e.target.files;
      this.files = [];
      if (!lstFiles.length) return false;
      for (let i = 0; i < lstFiles.length; i++) {
        this.files.push(lstFiles[i]);
      }
    },
    onRowSelected(demands) {
      showLoader();
      this.demandSelected = {id: null};
      console.log("onRowSelected");
      // this.demandSelected = demands[0];
      // console.log(demands[0]);

      setTimeout(() => {
        this.demandSelected = demands[0];
        hideLoader();
        }, 100);

      // LLAMAR AL OTRO COMPONENTE DE GESTIONES Y PASARLE ID DE LA DEMANDA
    },
    getPDF(id) {
      showLoader();
      this.$http
        .post(
          `${this.$urlApi}report/demand/tasks?token=${this.token}`,
          JSON.stringify({
            demand_id: id,
            customer_name: this.customer_name,
            total_debt: this.total_debt
          }),
          {
            headers: { "Content-Type": "application/json" },
            responseType: "blob"
          }
        )
        .then(
          function(response) {
            console.log(response);
            _downloadFile(response, "gestiones-demanda-"+id);
            hideLoader();
          },
          error => {
            console.log(error);
            hideLoader();
          }
        );
    },
  },
};
</script>
